<template>
  <div class="section center initial-section" id="initialSection">
    <!-- <div class="info-top">
      MEMÓRIA, LUTO E LUTA EM TEMPOS DE PANDEMIA: <br />ESTRATÉGIAS CULTURAIS
      PARA AFIRMAÇÃO DA VIDA DIANTE DA GESTÃO DA MORTE NAS PRISÕES
    </div> -->

    <scroll-observer
      @start="playAnimation"
      sentinalName="obb"
    ></scroll-observer>
    <div v-if="showLogo" class="text-title">
      COVID²
      <div class="console-container">
        <span id="text"></span>
        <div class="console-underscore" id="console">&#95;</div>
        <div
          class="colchetes animate__animated animate__fadeIn animate__delay-3s"
        >
          [ ]
        </div>
      </div>
    </div>
    <img
      class="image-logo mt-4"
      src="@/assets/images/infovirus-logo.png"
      alt="Logo Infovírus"
    />
    <div v-if="start" class="exposicao-musica">
      <div class="item" @click="startComMusica">
        <div class="icon"><i class="bi bi-volume-up"></i></div>
        <div class="text">Iniciar com música de fundo</div>
      </div>
      <div class="item" @click="startSemMusica">
        <div class="icon"><i class="bi bi-volume-mute"></i></div>
        <div class="text">Iniciar sem música de fundo</div>
      </div>
    </div>
    <div v-if="!start" class="role-baixo">
      <div>role para ver a exposição</div>
    </div>
    <div v-if="!start" class="seta">
      <i class="bi bi-chevron-double-down"></i>
    </div>
  </div>
</template>

<script>
import scrollTo from "@degjs/scroll-to";
export default {
  data() {
    return {
      showLogo: true,
    };
  },
  mounted() {
    this.consoleText(["a pandemia nas prisões"], "text", ["#DC793A"]);
  },
  computed: {
    start() {
      return this.$store.state.start;
    },
  },
  methods: {
    startComMusica() {
      this.$store.commit("startSound");
      setTimeout(() => {
        let destinationElement = document.getElementById("n1Section");
        scrollTo({
          element: destinationElement,
          duration: 100,
          easing: "easeInOut",
        });
      }, 100);
    },
    startSemMusica() {
      this.$store.commit("startNoSound");
      setTimeout(() => {
        let destinationElement = document.getElementById("n1Section");
        scrollTo({
          element: destinationElement,
          duration: 100,
          easing: "easeInOut",
        });
      }, 100);
    },
    playAnimation() {
      this.showLogo = false;
      setTimeout(() => {
        this.showLogo = true;
        setTimeout(() => {
          this.consoleText(["a pandemia nas prisões"], "text", ["#DC793A"]);
        }, 50);
      }, 100);
    },
    consoleText(words, id, colors) {
      if (colors === undefined) colors = ["#fff"];
      var visible = true;
      var con = document.getElementById("console");
      var letterCount = 1;
      var x = 1;
      var waiting = false;
      var target = document.getElementById(id);
      target.setAttribute("style", "color:" + colors[0]);
      window.setInterval(function () {
        if (letterCount === "a pandemia nas prisões".length + 1) {
          waiting = true;
        } else if (letterCount === 0 && waiting === false) {
          waiting = true;
          target.innerHTML = words[0].substring(0, letterCount);
          window.setTimeout(function () {
            var usedColor = colors.shift();
            colors.push(usedColor);
            var usedWord = words.shift();
            words.push(usedWord);
            x = 1;
            target.setAttribute("style", "color:" + colors[0]);
            letterCount += x;
            waiting = false;
          }, 1000);
        } else if (letterCount === words[0].length + 1 && waiting === false) {
          waiting = true;
          window.setTimeout(function () {
            x = -1;
            letterCount += x;
            waiting = false;
          }, 1000);
        } else if (waiting === false) {
          target.innerHTML = words[0].substring(0, letterCount);
          letterCount += x;
        }
      }, 120);
      window.setInterval(function () {
        if (visible === true) {
          con.className = "console-underscore hidden";
          visible = false;
        } else {
          con.className = "console-underscore";
          visible = true;
        }
      }, 400);
    },
  },
};
</script>

<style lang="scss" scoped>
.initial-section {
  background-color: #fff;
}
.info-top {
  width: 700px;
  text-align: center;
  line-height: 1.1rem;
  color: #101820;
  position: absolute;
  top: 40px;
  font-family: Roboto Condensed;
  font-weight: 300;
}

.bi-chevron-double-down {
  margin-bottom: -15px;
  font-size: 1.1rem;
}

.exposicao-musica {
  position: absolute;
  bottom: 80px;
  display: flex;
  width: 330px;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: white;
  column-gap: 25px;
  margin-right: 64px;

  .item {
    cursor: pointer;
    background-color: #dc793bd2;
    border-radius: 7px;
    padding: 10px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 5px;
  }

  .icon {
    font-size: 32px;
  }
  .text {
    padding: 0 0px;
  }
}

.colchetes {
  opacity: 0;
  color: #dc793a;
  font-size: 5rem;
  letter-spacing: 6rem;
  white-space: nowrap;
  position: absolute;
  margin-left: -50px;
  top: 20px;
}

.role-baixo {
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #626262;
  position: absolute;
  bottom: 80px;
}

.seta {
  position: absolute;
  bottom: 50px;
  animation: SlideDown 1s ease-in-out infinite;
}

.console-container {
  font-family: Roboto Mono;
  font-size: 2rem;
  line-height: 2.1rem;
  width: 260px;
  display: block;
  position: relative;
  margin-top: 10px;
  height: 76px;
}
.console-underscore {
  display: inline-block;
  position: relative;
  top: -0.14rem;
  left: 10px;
  color: #dc793a;
}

.image-logo {
  margin-right: 265px;
}
.text-title {
  font-size: 2rem;
  font-family: Roboto Mono;
  width: 300px;
  line-height: 2.1rem;
  color: #101820;
  font-weight: 300;
  margin-top: 30px;
  & span {
    color: #dc793a;
  }
}

@media screen and (max-width: 480px) {
  .info-top {
    width: 90%;
    margin-top: 50px;
  }

  .image-logo {
    margin-right: 200px;
    width: 80px;
  }

  .text-title {
    margin-left: 48px;
  }

  .colchetes {
    max-width: 100%;
  }

  .exposicao-musica {
    margin-right: 15px;
    margin-bottom: 30px;
  }
}
@keyframes SlideDown {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(10px);
  }
}
</style>